import { graphql, HttpResponse } from 'msw'
import { type InvestmentTradeDetail, InvestmentTradeStatus, type InvestmentTradeConfirmsOutput } from '../../../models'

export const investmentTradeDetailMock: InvestmentTradeDetail = {
  __typename: 'InvestmentTradeDetail',
  tradeId: 101,
  displayName: 'Apple',
  amountCash: {
    amount: 1000,
    currencyCode: 'USD',
  },
  quantity: 0.00313438,
  status: InvestmentTradeStatus.PENDING,
  executedTime: new Date().toISOString(),
  instrument: {
    __typename: 'MutualFundInstrument',
    name: 'Apple Inc',
    description: 'Apple Inc',
    symbol: 'AAPL',
    priorClosePrice: {
      amount: 100,
      currencyCode: 'USD',
    },
    image: 'https://drivewealth.imgix.net/symbols/aapl_1666583960.png?fit=fillmax&w=125&h=125&bg=FFFFFF',
  },
}

export const investmentTradeConfirmsMock: InvestmentTradeConfirmsOutput = {
  confirms: [
    {
      displayName: 'Apple',
      fileKey: 'fileKey',
      alias: 1,
    },
  ],
}

export const mockGetInvestmentTradeDetailHandler = graphql.query(`investmentTradeDetail`, () => {
  return HttpResponse.json({ data: { investmentTradeDetail: investmentTradeDetailMock } })
})

export const mockGetInvestmentTradeConfirmsHandler = graphql.query(`investmentTradeConfirms`, () => {
  return HttpResponse.json({ data: { investmentTradeConfirms: investmentTradeConfirmsMock } })
})

export const mockInvestmentTradeDetail = [mockGetInvestmentTradeDetailHandler, mockGetInvestmentTradeConfirmsHandler]
